import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import axios from 'axios';
import { vxm } from '@/store.vuex';
import { LicenceMasterDataList } from '../licence/LicenceMasterDataList';
import { DocumentPayload } from '../../models/skills/documentpayload';
import { UserLicence } from './UserLicence';
import { UserLicenceList } from '../licence/UserLicenceList';
import { LicenceSave } from '../licence/LicenseSave';
import { LicenceDocument } from '../licence/LicenceDocument';
import { LicenceUploadPayload } from '../licence/LicenceUploadPayload';
import { Pager } from '@/models/jobs/pager';

@Module({ namespacedPath: 'licence/' })
export class LicenceStore extends VuexModule {
  private licenseMasterDataWrapper: LicenceMasterDataList = new LicenceMasterDataList();
  private userLicenceList: UserLicence[] = [];
  private saveLicence: LicenceSave = new LicenceSave();
  private licenceList: Array<any> = [];
  private licencePager: Pager = new Pager();
  public get LicenseMasterDataWrapper(): LicenceMasterDataList {
    return this.licenseMasterDataWrapper;
  }

  public get LicenceList() {
    return this.licenceList;
  }

  public get UserLicenceList(): UserLicence[] {
    return this.userLicenceList;
  }

  public get LicencePager() {
    return this.licencePager;
  }

  @mutation
  public setUserLicenseData(uld: UserLicence[]) {
    this.userLicenceList = uld;
  }

  @mutation
  public setLicencePager(page) {
    this.licencePager.resultCount = page.totalCount;
    this.licencePager.resultPage = page.pageNumber;
    this.licencePager.resultSize = page.pageSize;
    this.licencePager.totalPages = Math.ceil(page.totalCount / page.pageSize);
  }

  @mutation
  public setLicenceList(payload) {
    this.licenceList = payload;
  }

  @mutation
  public setCompanyLicenceWrapper(lmdw: LicenceMasterDataList) {
    this.licenseMasterDataWrapper = lmdw;
  }

  @action({ mode: 'mutate' })
  public async getCompanyLicenceData() {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      '/wl-profile-svc/api/v1/licences',
      //'https://run.mocky.io/v3/b85c33cd-ad13-444b-b111-5dab66fb9444',
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    if (resp.data.meta.success) {
      this.setCompanyLicenceWrapper(resp.data.data);
    }
  }

  @action({ mode: 'mutate' })
  public async getUserLicenceData(
    { pageNumber, pageSize } = { pageNumber: 1, pageSize: 3 },
  ) {
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.get(
      `/wl-profile-svc/api/v1/userLicences?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    console.log(resp);
    if (resp.data.meta.success) {
      this.setUserLicenseData(resp.data.data.licences);
      this.setLicencePager(resp.data.page);
    }
  }

  @action({})
  @action({ mode: 'mutate' })
  public async addLicenceToUserProfile(licenceSave: LicenceSave) {
    var formData = new FormData();
    formData.append('licenceInfo', JSON.stringify(licenceSave));
    const token = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/userLicences',
      formData,
      { headers: { 'Content-Type': 'application/json', Authorization: token } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async uploadLicenceDocument(payload: LicenceUploadPayload) {
    var formData = new FormData();
    console.log('file', payload.licenceDoc);
    if (payload.licenceDoc) {
      formData.append('licenceDoc', payload.licenceDoc);
    }
    formData.append('licenceInfo', JSON.stringify(payload.licenceInfo));
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/userLicences',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: bearerToken,
        },
      },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async deleteLicenceDocument(userLicenceDocId: number) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/userLicences/document/' + userLicenceDocId,
      null,
      { headers: { Authorization: bearerToken } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async removeLicence(licenceId: number) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v1/userLicences/' + licenceId,
      null,
      { headers: { Authorization: bearerToken } },
    );
    return resp.data;
  }

  @action({ mode: 'mutate' })
  public async fetchLicenceListByCategory(category: string) {
    const response = await axios.get(
      '/wl-profile-svc/api/v1/licences/category/' + category,
      {
        headers: {
          Authorization: 'Bearer ' + vxm.users.getToken,
        },
      },
    );
    this.setLicenceList(response.data.data.licences);
    return response;
  }
}
